export const GET_SYS_SETTINGS_REQUEST = "GET_SYS_SETTINGS_REQUEST";
export const GET_SYS_SETTINGS_SUCCESS = "GET_SYS_SETTINGS_SUCCESS";
export const GET_SYS_SETTINGS_FAIL = "GET_SYS_SETTINGS_FAIL";
export const GET_SYS_SETTINGS_RESET = "GET_SYS_SETTINGS_RESET";

export const UPDATE_SYS_SETTINGS_REQUEST = "UPDATE_SYS_SETTINGS_REQUEST";
export const UPDATE_SYS_SETTINGS_SUCCESS = "UPDATE_SYS_SETTINGS_SUCCESS";
export const UPDATE_SYS_SETTINGS_FAIL = "UPDATE_SYS_SETTINGS_FAIL";
